<template>
	<div class="modal-card">
		<header class="modal-card-head">
			<p class="modal-card-title">Importer des médias depuis un site internet</p>
		</header>
		<section class="modal-card-body">
			<b-field label="url">
                <b-input type="text" v-model="form.url" placeholder="http://www.site-internet.be/photo.jpg"></b-input>
			</b-field>
		</section>
		<footer class="modal-card-foot">
			<button class="button is-primary" @click="submit()" :disabled="form.processing">
				<i class="fa fa-spinner fa-pulse" v-show="form.processing"></i>
				&nbsp;
				<span>Importer</span>
			</button>
			<button class="button" type="button" @click="$parent.close()">Annuler</button>
		</footer>
	</div>
</template>

<script>
	import Form from 'form-backend-validation';

	export default {
    	data() {
        	return {
            	form: new Form({
            		model: "event",
                	model_id: this.$route.params.id,
                	url: '',
            }),
        }
    },
    
    methods: {

        submit() {

			this.form.post('/api/v1/medias')
			    .then( response => {
					this.$buefy.toast.open({
                        message: 'Votre document a été importé.',
                        type: 'is-success'
                    });

                    Bus.$emit('event.fetch');
                    this.$parent.close();

                }).catch( response => {
                    this.$buefy.toast.open({
                        message: 'Une erreur s\'est produite',
                        type: 'is-danger'
                    });
                });
        },
    },
}
</script>

<style>
</style>
